const Cache: Record<
  string,
  {
    expireAt?: Date;
    promise: Promise<unknown>;
  }
> = {};

export const memoize = <V>(
  cacheKey: string,
  fn: () => Promise<V>,
  expireIn?: number /* ms */
): Promise<V> => {
  const cachedValue = Cache[cacheKey];
  if (cachedValue?.expireAt > new Date()) {
    return Cache[cacheKey].promise as Promise<V>;
  }

  const promise = fn();

  Cache[cacheKey] = {
    expireAt: expireIn ? new Date(Date.now() + expireIn) : new Date(2222, 1, 1),
    promise,
  };

  return promise;
};
